import {inject} from '@angular/core';
import {type ResolveFn} from '@angular/router';
import {HomePageContent, UiConfigService} from '@middleware';
import {map} from 'rxjs/operators';

export const homeContentResolver: ResolveFn<HomePageContent | null> = () => {
  return inject(UiConfigService)
    .getInstanceUIConfig()
    .pipe(map(config => config?.config_data?.content?.homepage ?? null));
};
